/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { PageOutputDto } from '../model/pageOutputDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
    providedIn:'root'
})
export class PageService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPageGetGet(observe?: 'body', reportProgress?: boolean): Observable<PageOutputDto>;
    public apiPageGetGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageOutputDto>>;
    public apiPageGetGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageOutputDto>>;
    public apiPageGetGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PageOutputDto>('get',`${this.basePath}/api/Page/Get`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdPage 
     * @param dsAboutUs 
     * @param aboutImg 
     * @param dsNewAboutImg 
     * @param dsHow 
     * @param howImg 
     * @param dsNewHowImg 
     * @param dsFaq 
     * @param dsContactUs 
     * @param dsSData 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPagePutPutForm(cdPage?: number, dsAboutUs?: string, aboutImg?: Blob, dsNewAboutImg?: string, dsHow?: string, howImg?: Blob, dsNewHowImg?: string, dsFaq?: string, dsContactUs?: string, dsSData?: string, observe?: 'body', reportProgress?: boolean): Observable<PageOutputDto>;
    public apiPagePutPutForm(cdPage?: number, dsAboutUs?: string, aboutImg?: Blob, dsNewAboutImg?: string, dsHow?: string, howImg?: Blob, dsNewHowImg?: string, dsFaq?: string, dsContactUs?: string, dsSData?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageOutputDto>>;
    public apiPagePutPutForm(cdPage?: number, dsAboutUs?: string, aboutImg?: Blob, dsNewAboutImg?: string, dsHow?: string, howImg?: Blob, dsNewHowImg?: string, dsFaq?: string, dsContactUs?: string, dsSData?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageOutputDto>>;
    public apiPagePutPutForm(cdPage?: number, dsAboutUs?: string, aboutImg?: Blob, dsNewAboutImg?: string, dsHow?: string, howImg?: Blob, dsNewHowImg?: string, dsFaq?: string, dsContactUs?: string, dsSData?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {











        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (cdPage !== undefined) {
            formParams = formParams.append('CdPage', <any>cdPage) as any || formParams;
        }
        if (dsAboutUs !== undefined) {
            formParams = formParams.append('DsAboutUs', <any>dsAboutUs) as any || formParams;
        }
        if (aboutImg !== undefined) {
            formParams = formParams.append('AboutImg', <any>aboutImg) as any || formParams;
        }
        if (dsNewAboutImg !== undefined) {
            formParams = formParams.append('DsNewAboutImg', <any>dsNewAboutImg) as any || formParams;
        }
        if (dsHow !== undefined) {
            formParams = formParams.append('DsHow', <any>dsHow) as any || formParams;
        }
        if (howImg !== undefined) {
            formParams = formParams.append('HowImg', <any>howImg) as any || formParams;
        }
        if (dsNewHowImg !== undefined) {
            formParams = formParams.append('DsNewHowImg', <any>dsNewHowImg) as any || formParams;
        }
        if (dsFaq !== undefined) {
            formParams = formParams.append('DsFaq', <any>dsFaq) as any || formParams;
        }
        if (dsContactUs !== undefined) {
            formParams = formParams.append('DsContactUs', <any>dsContactUs) as any || formParams;
        }
        if (dsSData !== undefined) {
            formParams = formParams.append('DsSData', <any>dsSData) as any || formParams;
        }

        return this.httpClient.request<PageOutputDto>('put',`${this.basePath}/api/Page/Put`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
